
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import ScheduleHeader from '@/components/utils/PopulateForms/components/ScheduleHeader.vue';
import { schedule2AboutOrderInfoType } from '@/types/Application/ProtectionOrder/PDF';

@Component({
    components: {
        UnderlineForm,
        GreyBoxForm,
        CheckBox,
        ScheduleHeader
    }
})
export default class Schedule2 extends Vue {

    @Prop({ required: true })
    result!: any;

    aboutOrder = {} as schedule2AboutOrderInfoType;

    dataReady = false;

    mounted() {
        this.dataReady = false;
        this.getAboutOrder();
        this.dataReady = true;
    }

    public getAboutOrder() {

        this.aboutOrder = { dateOfPO: '', inCourtForPO: '', whyNotInCourt: '', kindOfParty: [], whatChangesNeeded: '', whyChangesNeeded: '' };

        if (this.result?.aboutSurvey) {
            const about = this.result.aboutSurvey;
            this.aboutOrder.dateOfPO = about.dateOfPO;
            this.aboutOrder.inCourtForPO = about.inCourtForPO;
            this.aboutOrder.whyNotInCourt = about.inCourtForPO == 'n' ? about.whyNotInCourt : '';
            this.aboutOrder.kindOfParty = about.kindofPartyIbPO ? about.kindofPartyIbPO : [];
            this.aboutOrder.whatChangesNeeded = about.whatChangesNeeded;
            this.aboutOrder.whyChangesNeeded = about.whyChangesNeeded;
        }
    }
}
